import { Model } from 'pinia-orm';
import Company from './Company';

export default class Jobsite extends Model {

    static get entity () {
        return 'jobsites'
    }

    static fields () {
        return {
            id: this.attr(null),
            company_id: this.attr(null),
            active_languages: this.attr([]),
            labels: this.attr({}),
            header_url: this.attr(''),
            favicon_url: this.attr(''),
            og_image_url: this.attr(''),
            favicons: this.attr({}),
            has_favicons: this.attr(null),
            companypage_header1: this.attr({}),
            header_caption: this.attr({}),
            display_font: this.attr(''),
            text_font: this.attr(''),
            primary_color: this.attr(''),
            secondary_color: this.attr(''),
            custom_css: this.attr(''),
            disclaimer: this.attr({}),
            rounding: this.number(10),
            padding: this.number(25),
            gtm_container_id: this.attr(''),
            ga_container_id: this.attr(''),
            display_cookie_banner: this.attr(false),
            share_anonymous_data: this.attr(false),
            og_title: this.attr({}),
            og_description: this.attr({}),
            cookie_banner: this.attr({}),
            cookie_policy: this.attr({}),
            cookie_policy_file_name: this.attr({}),
            cookie_policy_file_original_name: this.attr({}),
            cookie_policy_file_extension: this.attr({}),
            cookie_policy_file_url: this.attr({}),
            default_lang: this.attr(''),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        }
    }
}
